import { useContext } from 'react';
import { CoursesStore } from '.';

export default function useCourses() {
  return useContext(CoursesStore);
}
